import React from "react";
import Webcam from "react-webcam";

const PhotoCapture = ({
  capturedPhotos,
  setCapturedPhotos,
  webcamRef,
  showCamera,
  setShowCamera,
  isMobile
}) => {
  const capturePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      setCapturedPhotos((prev) => [...prev, imageSrc]);
    }
  };

  const removePhoto = (index) => {
    setCapturedPhotos((prev) => prev.filter((_, i) => i !== index));
  };

  const videoConstraints = {
    facingMode: isMobile ? { exact: "environment" } : "user",
  };

  return (
    <div className="w-full flex flex-col py-4">
      <label className="font-bold text-black">Capturar Fotos</label>
      <button
        type="button"
        onClick={() => setShowCamera((prev) => !prev)}
        className="mt-2 mx-auto px-4 py-2 bg-rs-azul text-white rounded hover:bg-rs-rojo"
      >
        {showCamera ? "Ocultar Cámara" : "Activar Cámara"}
      </button>

      {showCamera && (
        <>
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={videoConstraints}
            className="rounded-md border border-gray-400 w-full max-w-sm mt-4"
          />
          <div className="flex justify-center mt-2">
            <button
              type="button"
              onClick={capturePhoto}
              className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            >
              Tomar Foto
            </button>
          </div>
        </>
      )}

      {capturedPhotos.length > 0 && (
        <div className="mt-4 grid grid-cols-2 md:grid-cols-3 gap-4">
          {capturedPhotos.map((photo, index) => (
            <div key={index} className="relative">
              <img src={photo} alt={`foto-${index}`} className="w-full rounded border" />
              <button
                type="button"
                onClick={() => removePhoto(index)}
                className="absolute top-1 right-1 bg-red-600 text-white text-xs rounded-full px-2"
              >
                X
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PhotoCapture;